export enum RegistrationChannel {
  Web = 'Web',
}
